// 第1张
const imgAllA = {
    NA: {
        poster: 'https://websiteoss.ecoflow.com/upload/image/1724571229535/a2.jpg',
        posterH5: 'https://websiteoss.ecoflow.com/upload/image/1724571229361/b2.jpg',
        pc: 'https://websiteoss.ecoflow.com/upload/video/1732245741773/video.mp4',
        h5: 'https://websiteoss.ecoflow.com/upload/video/1732245741773/video.mp4',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725012205888/euPC1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725012543171/euH1.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725012351965/ukPC1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725012642926/ukH1.jpg',
    },
    PH: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751091172781/F1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1751091171886/F1-m.jpg',
    },
};
export const imgLocaleA: any = {
    us: imgAllA.NA,
    ca: imgAllA.NA,
    br: imgAllA.NA,
    mx: imgAllA.NA,
    uk: imgAllA.UK,
    eu: imgAllA.EU,
    de: imgAllA.EU,
    fr: imgAllA.EU,
    it: imgAllA.EU,
    es: imgAllA.EU,
    ph: imgAllA.PH,
};

// 第2张
const imgAllB = {
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724571229188/a1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724571229711/b1.jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725012206013/euPC2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725012543535/euH2.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725012351759/ukPC2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725012643145/ukH2.jpg',
    },
    PH: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751091172605/F2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1751091172426/F2-m.jpg',
    },
};
export const imgLocaleB: any = {
    us: imgAllB.NA,
    ca: imgAllB.NA,
    br: imgAllB.NA,
    mx: imgAllB.NA,
    uk: imgAllB.UK,
    eu: imgAllB.EU,
    de: imgAllB.EU,
    fr: imgAllB.EU,
    it: imgAllB.EU,
    es: imgAllB.EU,
    ph: imgAllB.PH,
};

// 第3张
const imgAllC = {
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724571229002/a3.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724571228847/b3.jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725012206398/euPC3.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725012543344/euH3.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725012352114/ukPC3.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725012643328/ukH3.jpg',
    },
    PH: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751091172061/F3.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1751091172240/F3-m.jpg',
    },
};
export const imgLocaleC: any = {
    us: imgAllC.NA,
    ca: imgAllC.NA,
    br: imgAllC.NA,
    mx: imgAllC.NA,
    uk: imgAllC.UK,
    eu: imgAllC.EU,
    de: imgAllC.EU,
    fr: imgAllC.EU,
    it: imgAllC.EU,
    es: imgAllC.EU,
    ph: imgAllC.PH,
};
